import { render, staticRenderFns } from "./insstatistic.vue?vue&type=template&id=eda8363c&scoped=true&"
import script from "./insstatistic.vue?vue&type=script&lang=js&"
export * from "./insstatistic.vue?vue&type=script&lang=js&"
import style0 from "./insstatistic.vue?vue&type=style&index=0&id=eda8363c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda8363c",
  null
  
)

export default component.exports